<template>
  <div class="labeled-copy-input">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <CopyInput
      ref="textInput"
      :id="inputId"
      :value="value"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :limit="limit"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <slot />
    </CopyInput>
  </div>
</template>

<script>
import { default as CopyInput } from '../copy-input';
import { default as InputLabel } from '../label';
import { RandomId } from '@/shared/lib/random';

const { generateRandomId } = RandomId();

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      inputId: `input-text-${this.generateRandomId()}`,
    };
  },
  components: { InputLabel, CopyInput },
  computed: {
    getTextInput() {
      return this.$refs.textInput;
    }
  },
  methods: {
    generateRandomId,
  },
};
</script>
